// App.js - обновленная версия
import React from "react";
import NavBar from "./NavBar"; // Импортируем переименованный компонент
import GlobalCursor from '../components/GlobalCursor/GlobalCursor.jsx';
import ContactSection from "./ContactSection";
import SelebritySection from "./Selebrity";
import Footer from "./Footer";
import "./App.css";

function celebrityApperances() {
  return (
    <div className="App">
      <GlobalCursor />
      <NavBar /> {/* Используем переименованный компонент */}
      
     
      <SelebritySection />
      <ContactSection />

      <Footer />
    </div>
  );
}

export default celebrityApperances;